import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { axiosErrorHandler } from "../../../../swzutils";
import CommunicationTable from "../../components/CommunicationTable";
const VehicleHireCommunications = ({ vehicleHireId }) => {
    const [loading, setLoading] = useState(false);
    const [communications, setCommunications] = useState([]);
    useEffect(() => {
        if (vehicleHireId) {
            loadCommunications();
        }
    }, [vehicleHireId]);
    const loadCommunications = () => {
        setLoading(true);
        if (vehicleHireId) {
            axios.get(`/admin/v1/vehicle-hires/${vehicleHireId}/communications`)
                .then(response => setCommunications(response.data))
                .catch((error) => {
                if (error.response.status !== 404) {
                    axiosErrorHandler(error);
                }
            })
                .finally(() => setLoading(false));
        }
    };
    return _jsx(CommunicationTable, { loading: loading, communications: communications });
};
export default VehicleHireCommunications;
